import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { NAME_SPACES, RESOURCES } from "./i18nResources";
import { LanguageEnum } from "@/types/enums";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: RESOURCES,
    ns: NAME_SPACES,
    defaultNS: "components",
    fallbackLng: LanguageEnum.EN,
    supportedLngs: [LanguageEnum.EN, LanguageEnum.ZH, LanguageEnum.FR],
    interpolation: { escapeValue: false },
    detection: {
      order: ["path", "localStorage", "navigator"],
      lookupFromPathIndex: 0,
    },
  });

export default i18n;
